import React from 'react';
import PageLayout from '../../../global/partialBase/pageLayout';
import ManifestOrderBody from './body';

const ManifestOrder = () => {
    return (
        <div>
            <PageLayout tabMenu={true} body={<ManifestOrderBody />} selectedItem = "Manifests" />
        </div>
    )
}

export default ManifestOrder;